let accessToken = '';//已废弃
let authorizeCode='';

const config = {
  // 后台接口域名（末尾不要带斜杠）
  baseURL: 'https://api.dazy-tech.cn',


  setToken(token) {
    accessToken = token;
  },

  getToken() {
    return accessToken;
  },
  setAuthorizeCode(code) {
    authorizeCode = code;
  },
  
  getAuthorizeCode() {
    return authorizeCode;
  },
};

export default config;
